<template>
  <div :id="id" class="c-form-dropdown-field-wrapper">
    <validation-message
      :valid="valid"
      :invalid="invalid"
      :validationMessage="validationMessage"
    >
      <div class="c-form-dropdown-field">
        <text-field
          :label="inputLabel"
          id="input"
          :type="type"
          :disabled="disabled"
          :required="required"
          v-model="inputValue"
          @change="updateInputValue"
        />
        <select-dropdown
          :label="selectLabel"
          id="select"
          :options="options"
          v-model="selectValue"
          :aria-label="`${selectLabel} ${getSelectedOptionLabel}`"
          @change="changeSelectValue"
        />
      </div>
    </validation-message>

    <div v-if="tooltip" class="c-tooltip">
      <ToolTip
        :title="tooltipTitle"
        :isActive="isActiveTooltip"
        @toggleTooltip="(value) => $emit('toggleTooltip', value)"
      >
        <span v-html="tooltipMessage"></span>
        <img
          v-if="tooltipImageUrl"
          class="test"
          width="84"
          height="117"
          :src="tooltipImageUrl"
        />
      </ToolTip>
    </div>
  </div>
</template>

<script>
import ValidationMessage from '../../../../base/validation-message/ValidationMessage.vue';
import ToolTip from '../../../../components/consumer/_contact-us-rap/_vue/ToolTip.vue';
import TextField from '../../../../components/consumer/forms/input/TextField.vue';
import SelectDropdown from '../../../../components/consumer/forms/select/SelectDropdown.vue';

export default {
  components: { ValidationMessage, ToolTip, TextField, SelectDropdown },
  inheritAttrs: false,
  props: {
    id: { required: true, type: String },
    inputLabel: { required: true, type: String },
    selectLabel: { required: true, type: String },
    required: { type: Boolean, required: false },
    disabled: { type: Boolean, required: false },
    tooltip: { type: Boolean, required: false },
    tooltipTitle: { type: String, required: false },
    tooltipMessage: { type: String, required: false },
    tooltipImageUrl: { type: String, default: '', required: false },
    isActiveTooltip: { type: Boolean },
    type: { type: String, default: 'text', required: false },
    value: { type: [String, Number] },
    inputValue: { type: [String, Number] },
    selectValue: { type: [String, Number, null], default: null },
    options: { type: Array, required: true },
    valid: { type: Boolean, default: null },
    invalid: { type: Boolean, default: null },
    readonly: { type: Boolean, default: false },
    validationMessage: { type: String, required: false },
  },
  computed: {
    errorId() {
      return `${this.id}ErrorMsg`;
    },
    requiredCssClass() {
      return this.required ? 'c-form-textfield__label--required' : '';
    },
    getSelectedOptionLabel() {
      const selected = this.options.find(
        (opt) => opt.value === this.selectValue
      );
      return selected ? selected.label : '';
    },
  },
  methods: {
    updateInputValue(value) {
      this.inputValue = value;
      this.$emit('onInputValue', value);
    },
    changeSelectValue(value) {
      this.selectValue = value.value;
      this.$emit('onSelectValue', value);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/components/consumer/_contact-us-rap/_vue/DropdownField.vue